import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Industryusa = () => {
  return (
    <div className="Industry_usa tekrevol_dark_bg  p-100 ">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={5} lg={5} xl={5} xxl={5}>
            <h2>
              TekRevol's Array of <span>Unity Game Development</span> Categories
            </h2>
            <p>
              Dive into TekRevol's Unity game development genres, crafting
              everything from action-packed adventures to mind-bending puzzle
              games. Gaming excitement, tailored to your preferences!
            </p>
            <p>
              Here are the game development categories that we have expertise
              in:
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Build Your Game App Now!
            </Link>
          </Col>
          <Col
            xs={12}
            md={4}
            lg={4}
            xl={4}
            xxl={4}
            className="offset-lg-3 offset-md-3 my-auto"
          >
            <div className="industry_scroll">
              <h3>Adventure Game</h3>
              <h3>Action Games</h3>
              <h3>Role-Playing Games</h3>
              <h3> Casual Games</h3>
              <h3>First-Person Shooter</h3>
              <h3>Puzzle Games</h3>
              <h3>Battle Royale Games</h3>
              <h3>Sports Games</h3>
              <h3>Strategy Games</h3>
              <h3>Indie Games</h3>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Industryusa;
